/**
 * Map Rango global.tickers (keyed by peatio market id) → Shahoo statMap (BASE_QUOTE).
 * Mirrors Shahoo-BFF mapTickersToStatMap / marketIdToShahooStatKeys.
 */

function marketIdToShahooStatKeys(marketId) {
  const id = String(marketId || "").toLowerCase();
  const match = id.match(/^([a-z0-9]+?)(cad|irt|usdt)$/);
  if (!match) return [];
  return [`${match[1].toUpperCase()}_${match[2].toUpperCase()}`];
}

function num(raw, fallback = 0) {
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * @param {Record<string, object>} tickers — Rango/Dena ticker map
 * @param {Record<string, object>} [prev] — previous statMap to merge
 */
export function mapRangerTickersToStatMap(tickers, prev = {}) {
  const statMap = { ...prev };

  Object.entries(tickers || {}).forEach(([marketId, entry]) => {
    const keys = marketIdToShahooStatKeys(marketId);
    if (!keys.length) return;

    const unitPrice = num(entry?.last ?? entry?.ticker?.last);
    const dayClose = num(entry?.open ?? entry?.ticker?.open, unitPrice);
    const dayHigh = num(entry?.high ?? entry?.ticker?.high, unitPrice);
    const dayLow = num(entry?.low ?? entry?.ticker?.low, unitPrice);
    const volumeDst = num(
      entry?.volume ?? entry?.amount ?? entry?.ticker?.volume
    );

    keys.forEach((key) => {
      statMap[key] = {
        unitPrice,
        market: key,
        dayClose,
        dayHigh,
        dayLow,
        volumeDst,
        bestBuyPrice: unitPrice,
        bestSellPrice: unitPrice,
        priceChangePercent: entry?.price_change_percent,
      };
    });
  });

  if (!statMap.USDT_IRT || !statMap.USDT_IRT.unitPrice) {
    statMap.USDT_IRT = { unitPrice: 1, market: "USDT_IRT" };
  }
  statMap.IRT_IRT = { unitPrice: 1, market: "IRT_IRT" };

  return statMap;
}

export { marketIdToShahooStatKeys };
